/*eslint-disable*/
import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import cx from "classnames";
// @mui/material components
import {withStyles} from "@mui/styles";
import Drawer from "@mui/material/Drawer";
// core components
import SidebarStyle from "../Sidebar/SidebarStyle";
import { LocationCity, PublicOutlined, Search } from "@mui/icons-material";
import SimpleSearch from "../Search/SimpleSearch";
import axios from "axios";
import { createTheme } from '@mui/material/styles';
import {
  makeStyles,
  ThemeProvider,
} from "@mui/styles";
import TreeItem from "@mui/lab/TreeItem";
import Typography from "@mui/material/Typography";
import TreeView from "@mui/lab/TreeView";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import { FormControlLabel, Switch } from "@mui/material";
import { green } from "@mui/material/colors";
import AdvancedSearchContext from "../../context/AdvancedSearchContext";
import EntiteContext from "../../context/EntiteContext";
import UserService from "../../services/UserService";
import { getArchitecture } from "../../services/ConfigServices";
import batimentArbre from "assets/img/tree/Batiment-arbre-15x15.png";
import communeArbre from "assets/img/tree/Commune-arbre-15x15.png";
import entiteArbre from "assets/img/tree/Entité-arbre-15x15.png";
import feuArbre from "assets/img/tree/Feu-arbre-15x27.png";
import groupeArbre from "assets/img/tree/Groupe-arbre-15x15.png";
import siteArbre from "assets/img/tree/Site-arbre-15x15.png";
import zoneArbre from "assets/img/tree/Zone-arbre-15x15.png";
import compteArbre from "assets/img/tree/Compte-arbre-15x15.png";
import OverflowTip from "./OverflowTip";
import 'assets/css/MenuEntites/MenuEntites.css'; // Tell webpack that Button.js uses these styles
import ReactDOM from "react-dom";

function GroupeArbre() {
  return (
    <img src={groupeArbre} alt={"icone la terre"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function BatimentArbre() {
  return (
    <img src={batimentArbre} alt={"icone un batiment"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function CommuneArbre() {
  return (
    <img src={communeArbre} alt={"icone commune"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function EntiteArbre() {
  return (
    <img src={entiteArbre} alt={"icone entité"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function FeuArbre() {
  return (
    <img src={feuArbre} alt={"icone un feu tricolore"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function SiteArbre() {
  return (
    <img src={siteArbre} alt={"icone un site "} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function ZoneArbre() {
  return <img src={zoneArbre} alt={"icone zone "} style={{ margin: "2px 6px 2px 0" }} />;
}
function CompteArbre() {
  return (
    <img src={compteArbre} alt={"icone du compte"} style={{ margin: "2px 6px 2px 0" }} />
  );
}

function getTreeIcon(type, subtype) {
  let icon = CompteArbre;
  if (type == 0) {
    if (subtype == 0) icon = CommuneArbre;
    else if (subtype == 1) icon = EntiteArbre;
    else if (subtype == 2) icon = GroupeArbre;
    else icon = GroupeArbre;
  } else if (type == 1) {
    icon = SiteArbre;
  } else if (type == 2) {
    if (subtype == 0) icon = BatimentArbre;
    else if (subtype == 1) icon = FeuArbre;
    else icon = BatimentArbre;
  } else if (type == 3) {
    icon = ZoneArbre;
  } else if (type == 4) {
    icon = CompteArbre;
  }
  return icon;
}

class SidebarWrapper extends React.Component {
  sidebarWrapper = React.createRef();

  render() {
    const { className, user, headerLinks, dates, tree } = this.props;
    return (
      <div className={className} ref={this.sidebarWrapper}>
        {user}
        {headerLinks}
        {dates}
        {tree}
      </div>
    );
  }
}

const darkTheme = createTheme({
  palette: {
    type: "dark",
  },
});

const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    marginTop: "5px",
    color: "var(--tree-view-uneselected-color)",
    "&:hover > $content": {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    "&:focus > $content, &$selected > $content": {
      backgroundColor: "#636363",
      color: "var(--tree-view-color)",
    },
    "&$selected > $content": {
      backgroundColor: "#636363",
      color: "var(--tree-view-color)",
    },
  },
  treeGrid: {
    padding: "0 15px 0 7px",
  },
  content: {
    color: "var(--tree-view-uneselected-color)",
    //borderTopRightRadius: '16px',
    //borderBottomRightRadius: '16px',
    paddingRight: '8px',
    fontWeight: 500,
    "$expanded > &": {
      fontWeight: 400,
    },
  },
  group: {
    marginLeft: "6px",
    //'& $content': {
    //    paddingLeft: '16px',
    //},
  },
  expanded: {},
  selected: {
    "&:focus > $content, &$selected > $content": {
      backgroundColor: "#636363",
      color: "#fafafa",
    },
    "&$selected > $content": {
      backgroundColor: "#91C73C",
      color: "#fafafa",
    },
  },
  label: {
    fontWeight: "bold",
    backgroundColor: "transparent !important",
    paddingLeft: "0px",
  },
  // labelRoot: {
  //     display: 'flex',
  //     alignItems: 'center',
  //     padding: '0px 0px 0px 0px',
  // },
  // labelIcon: {
  //     marginRight: '6px',
  //     color: '#ffffff',
  //     fontSize: '1.1rem',
  //     width: '15px',
  //     height: '15px'
  // },
  // labelText: {
  //     fontWeight: 'normal',
  //     fontFamily: '"Source Sans Pro",sans-serif',
  //     flexGrow: 1,
  //     fontSize: '0.83rem',
  //     paddingTop: '4px'
  // },
  labelRoot: {
    //display: "-webkit-inline-box",
    display: "flex",
    alignItems: "center",
    padding: "0px 0px 0px 0px",
    maxWidth: "195px",
    minWidth: "0",
  },
  labelIcon: {
    marginRight: "6px",
    color: "#ffffff",
    fontSize: "1.1rem",
    width: "15px",
    height: "15px",
  },
  labelText: {
    fontWeight: "normal",
    fontFamily: '"Source Sans Pro",sans-serif',
    flexGrow: 1,
    fontSize: "0.83rem",
    paddingTop: "4px",
    whiteSpace: "nowrap",
    // maxWidth: "160px",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
  },
  labelTextInactive: {
    fontWeight: "normal",
    fontFamily: '"Source Sans Pro",sans-serif',
    flexGrow: 1,
    fontSize: "0.83rem",
    paddingTop: "4px",
    whiteSpace: "nowrap",
    fontStyle: "italic",
    // maxWidth: "160px",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
  },
}));

// const StyledTreeItem2 = React.forwardRef((props, ref) => {
//   const classes = useTreeItemStyles();
//   const {
//     children,
//     nodeId,
//     labelText,
//     labelIcon: LabelIcon,
//     labelInfo,
//     color,
//     bgColor,
//     unselectedcolor,
//     itemposition,
//     ...other
//   } = props;

//   return (
//     <TreeItem
//       itemposition={itemposition}
//       ref={ref}
//       key={nodeId}
//       nodeId={nodeId}
//       label={
//         <div className={classes.labelRoot}>
//           <LabelIcon color="inherit" className={classes.labelIcon} />
//           {/* <Typography variant="body2" className={classes.labelText}>
//             <OverflowTip value={labelText} someLongText={labelText} />
//           </Typography> */}
//           <Typography variant="body2" className={classes.labelText}>
//             <OverflowTip value={labelInfo} someLongText={labelInfo} />
//           </Typography>
//         </div>
//       }
//       style={{
//         "--tree-view-color": color,
//         "--tree-view-bg-color": bgColor,
//         "--tree-view-uneselected-color": unselectedcolor,
//       }}
//       classes={{
//         root: classes.root,
//         content: classes.content,
//         expanded: classes.expanded,
//         selected: classes.selected,
//         group: classes.group,
//         label: classes.label,
//       }}
//     >
//       {children}
//     </TreeItem>
//   );
// });

function StyledTreeItem2(props) {
  const classes = useTreeItemStyles();
  const {
    children,
    nodeId,
    labelText,
    labelIcon: LabelIcon,
    labelInfo,
    color,
    bgColor,
    unselectedcolor,
    inactive,
    ...other
  } = props;

  const textInput = useRef(null);

  if (labelInfo === 'Home')
    console.log(props);
  return (
    <TreeItem
      key={nodeId}
      nodeId={nodeId}
      label={
        <div className={classes.labelRoot}>
          <LabelIcon color="inherit" className={classes.labelIcon} />
          {/* <Typography variant="body2" className={classes.labelText}>
            <OverflowTip value={labelText} someLongText={labelText} />
          </Typography> */}
          <Typography variant="body2" className={inactive ? classes.labelTextInactive : classes.labelText}>
            <OverflowTip value={labelInfo} someLongText={labelInfo} />
          </Typography>
        </div>
      }
      style={{
        "--tree-view-color": color,
        "--tree-view-bg-color": bgColor,
        "--tree-view-uneselected-color": unselectedcolor,
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label,
      }}
    >
      {children}
    </TreeItem>
  );
}

StyledTreeItem2.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  unselectedcolor: PropTypes.string,
  labelIcon: PropTypes.elementType.isRequired,
  labelInfo: PropTypes.string,
  labelText: PropTypes.string
};

const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400,
  },
  treeGrid: {
    padding: "0 15px 0 7px",
  }
});
const classes = useStyles;

const StyledFormControlLabel = withStyles({
  label: {
    color: "#FFFFFF",
    fontSize: "0.83rem",
    "&disabled": {
      color: "#AAAAAA",
    },
  },
})(FormControlLabel);

//switch
const StyledSwitch = withStyles({
  switchBase: {
    color: "#91C73C",
    "&$checked": {
      color: "#91C73C",
    },
    "&$checked + $track": {
      backgroundColor: "#FFFFFF",
    },
  },
  checked: {},
  track: {},
})(Switch);

class MenuEntites extends React.Component {
  static contextType = AdvancedSearchContext;

  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      miniActive: false,
      selectDate: "1",
      simpleSearch: null,
      architecture: [],
      treeView: undefined,
      newTree: [],
      isFiltered: false,
      expanded: [],
      tmpExpanded: [],
      isMultiple: false,
      onSelectIds: [],
      chartIdGroup: [],
      firstSelectedId: false,
      multipleauthorized: false,
      inactivehidden: false,
    };
    this.firstelementsearchedfound = false;
    this.previousisMultiple = false;
    this.previousinactivehidden = false;
    this.nextItem = this.nextItem.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleCancelSearch = this.handleCancelSearch.bind(this);
    this.handleSwitchToMultipleSelect = this.handleSwitchToMultipleSelect.bind(this);
    this.handleSwitchInactiveHidden = this.handleSwitchInactiveHidden.bind(this);
  }

  listRef = React.createRef();
  searchedItems = [];
  groupInfoList = {};
  groupTypeList = {};
  mainPanel = React.createRef();


  componentDidMount() {
    this.previousContext = this.context;
    this.getArchitecture();
  }

  componentDidUpdate() {

    if (this.previousinactivehidden !== this.state.inactivehidden) {
      this.previousinactivehidden = this.state.inactivehidden;
      this.setState({
        treeView: this.getTreeView(this.state.architecture)
      });
    }
    if (this.previousisMultiple === true && this.state.isMultiple === false) {
      this.previousisMultiple === false;
      let newselection = [];
      if (Array.isArray(this.state.onSelectIds))
        newselection.push(this.state.onSelectIds[0])
      else
        newselection.push(this.state.onSelectIds)
      this.setState({
        onSelectIds: newselection,
      });
      this.context.setChartIdGroup(newselection);
      this.context.setSelectedNodesInfo(this.context.groupInfoListById["" + newselection]);
      this.props.handleGroupChange();
    }
    this.previousisMultiple = this.state.isMultiple;
    if (this.previousContext?.page !== this.context?.page) {
      if (this.context.page === 'maps' || this.context.page === 'analyse') {
        this.setState({
          multipleauthorized: true,
        });
      }
      else {
        this.setState({
          isMultiple: false,
          multipleauthorized: false,
        });
      }
    }
    if (
      this.previousContext?.treemustrefresh !== this.context?.treemustrefresh
    ) {
      let prevSelected = this.state.onSelectIds;
      let prevExpanded = this.state.expanded;
      if (this.context.groupchanged) {
        if (!prevExpanded.includes(prevSelected))
          //push father to prevexpanded
          prevExpanded.push(prevSelected);
        prevSelected = this.context.groupchanged;
        this.context.setGroupchanged("");
      }
      let prevSelectedNodesInfo = this.context.selectedNodesInfo;
      this.context.setTreemustrefresh(false);
      this.getArchitecture(prevExpanded, prevSelected, prevSelectedNodesInfo);
    }
    if (this.context?.outofcontextclic) {

      this.setState({
        //expanded: hasGroups ? prevExpanded ? prevExpanded : ["0", firstSelectedId] : ["0"],
        onSelectIds: this.context?.outofcontextclic,
      });
      this.defineExpanded(
        this.state.architecture,
        [this.context.outofcontextclic]
      );
      this.context.setOutofcontextclic("");
      this.props.handleGroupChange();
    }
    this.previousContext = this.context;
  }

  getArchitecture(prevExpanded, prevSelected, prevSelectedNodesInfo) {
    axios
      .get(getArchitecture(), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        const architecture = response.data.architecture;
        let firstSelectedId;
        let firstSelectedText = "";
        let hasGroups = false;
        if (response.data.architecture[0]) {
          firstSelectedId = response.data.architecture[0].id;
          firstSelectedText = response.data.architecture[0].text;
          hasGroups = true;
        }
        this.setState({ architecture: architecture });
        this.groupInfoList = {};
        this.groupTypeList = {};
        this.setState({
          treeView: this.getTreeView(this.state.architecture),
          isFiltered: false,
          expanded: hasGroups
            ? prevExpanded
              ? prevExpanded
              : ["0", firstSelectedId]
            : ["0"],
          onSelectIds: prevSelected ? prevSelected : firstSelectedId,
          firstSelectedId: true,
        });
        this.context.setGroupInfoListById(this.groupInfoList);
        this.context.setGroupTypeListById(this.groupTypeList);
        this.context.setChartIdGroup([
          prevSelected ? prevSelected : firstSelectedId,
        ]);
        this.context.setSelectedNodesInfo(
          prevSelectedNodesInfo ? prevSelectedNodesInfo : firstSelectedText
        );
        this.context.setArchitecture(architecture);
      })
      .catch((error) => {
        if (error.response) {
          console.error("ERROR", error.message);
        } else if (error.request) {
          console.error("request error", error.request);
          UserService.getLogout();
        }
      });
  }



  getTreeView(archiData) {
    return archiData.map((archiElement) => {
      this.groupInfoList["" + archiElement.id] = archiElement.text;
      this.groupTypeList["" + archiElement.id] = archiElement.type+"."+(archiElement.subtype || '0');
      let children = undefined;
      if (archiElement.children && archiElement.children.length > 0) {
        children = this.getTreeView(archiElement.children);
      }
      return (
        <StyledTreeItem2
          key={archiElement.id}
          nodeId={archiElement.id}
          labelText={archiElement.text}
          labelIcon={getTreeIcon(archiElement.type, archiElement.subtype)}
          children={children}
          color="#46464E"
          unselectedcolor="#FFFFFF"
          inactive={archiElement.r}
          hideinactive={archiElement.r && this.state.inactivehidden}
        />
      );
    });
  }

  getTreeViewSearched(archiData, ids) {
    return archiData.map((archiElement) => {

      let children = undefined;
      if (archiElement.children && archiElement.children.length > 0) {
        children = this.getTreeViewSearched(archiElement.children, ids);
      }
      let item_color = "#FFFFFF";


      if (ids.indexOf(archiElement.id) > -1) {
        item_color = "#91c241";

        if (!this.firstelementsearchedfound) {
          this.firstelementsearchedfound = true;
        }
        else {

        }

        let searchedItem = <StyledTreeItem2
          key={archiElement.id}
          nodeId={archiElement.id}
          labelText={archiElement.text}
          labelIcon={getTreeIcon(archiElement.type, archiElement.subtype)}
          children={children}
          color="#46464E"
          unselectedcolor={item_color}
          inactive={archiElement.r}
          hideinactive={archiElement.r && this.state.inactivehidden}
        />;
        this.searchedItems.push(searchedItem);
        return searchedItem;
      }
      else {
        return (
          <StyledTreeItem2
            key={archiElement.id}
            nodeId={archiElement.id}
            labelText={archiElement.text}
            labelIcon={getTreeIcon(archiElement.type, archiElement.subtype)}
            children={children}
            color="#46464E"
            unselectedcolor={item_color}
            inactive={archiElement.r}
            hideinactive={archiElement.r && this.state.inactivehidden}
          />
        );
      }

    });
  }

  defineExpanded(architecture, ids) {
    let inIds = false;
    architecture.forEach((element) => {
      let childInIds;
      childInIds = this.defineExpanded(element.children, ids);
      if (childInIds) {
        this.state.expanded.push(element.id);
        inIds = true;
      }
      if (ids.indexOf(element.id) > -1) {
        inIds = true;
      }
    });
    return inIds;
  }

  handleSearch() {
    let tmpExpandedA = [...this.state.expanded];
    this.setState({
      tmpExpanded: tmpExpandedA,
    });
    this.defineExpanded(this.state.architecture, this.props.ids);
    this.firstelementsearchedfound = false;
    this.itemSearchedCount = 0;
    this.setState({
      newTree: this.getTreeViewSearched(
        this.state.architecture,
        this.props.ids,
        false
      ),
      isFiltered: true,
    });

    //this.myRef.current.scrollIntoView();
    return this.state.architecture;
  }

  handleCancelSearch() {
    let expandedA = [...this.state.tmpExpanded];
    this.setState({
      treeView: this.getTreeView(this.state.architecture),
      isFiltered: false,
      expanded: expandedA,
    });
    return this.state.architecture;
  }

  nextItem() {

    // this.state.newTree.forEach(element => {
    //   console.log(element);

    // });
    // this.searchedItems.forEach(element => {
    //   console.log(element);
    //   console.log(ReactDOM.findDOMNode(element));
    // })
  }

  handleAdvancedTree = () => {
    const selectIds = this.context.resIds;
    const newNodeIds = [].concat([...selectIds]);

    this.defineExpanded(this.state.architecture, selectIds);
    this.setState({
      isMultiple: true,
      onSelectIds: newNodeIds,
    });
    this.context.setChartIdGroup(newNodeIds);
    if (newNodeIds.length > 1) {
      this.context.setSelectedNodesInfo(
        newNodeIds.length + " entités sélectionnées"
      );
    } else {
      this.context.setSelectedNodesInfo(
        newNodeIds.length + " entité sélectionnée"
      );
    }
  };

  handleSwitchToMultipleSelect(event) {
    this.setState({
      isMultiple: event.target.checked,
    });
  }
  handleSwitchInactiveHidden(event) {
    this.setState({
      inactivehidden: event.target.checked,
    });

  }


  createTree() {
    return (
      <div>
        <GridContainer>
          <GridItem>
            <SimpleSearch
              handleSearch={this.handleSearch}
              handleAdvanceTree={() => this.handleAdvancedTree()}
              ids={this.props.ids}
              handleCancelSearch={this.handleCancelSearch}
              nextItem={this.nextItem}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem>
            <StyledFormControlLabel
              control={
                <StyledSwitch
                  checked={this.state.inactivehidden}
                  color={'secondary'}
                  name={'inactivehiddenCheck'}
                  onChange={this.handleSwitchInactiveHidden}
                  inputProps={{
                    'aria-label': 'multiple select switch'
                  }}
                />
              }
              label={'Cacher les éléments inactifs'}
            />
          </GridItem>
          <GridItem>
            {
              this.state.multipleauthorized ?
                <StyledFormControlLabel
                  control={
                    <StyledSwitch
                      checked={this.state.isMultiple}
                      color={'secondary'}
                      name={'multipleCheck'}
                      onChange={this.handleSwitchToMultipleSelect}
                      inputProps={{
                        'aria-label': 'multiple select switch'
                      }}
                    />
                  }
                  label={'Sélection multiple'}
                /> : <></>
            }
          </GridItem>
          <GridItem
            className={"treeGrid"}
            style={{
              borderTop: "1px solid #868686"
            }}
          >
            <ThemeProvider theme={darkTheme}>
              <AdvancedSearchContext.Consumer>
                {({ setChartIdGroup, setSelectedNodesInfo, groupInfoListById }) => {
                  return (
                    <AutoSizer
                      style={{
                        width: "258px",
                        // height: `calc(100vh - 103px)`,
                        height: this.state.multipleauthorized ? `calc(100vh - 144px)` : `calc(100vh - 106px)`,
                      }}
                    >
                      {(size) => (
                        <TreeView
                          className={classes.root}
                          defaultCollapseIcon={<ArrowDropDownIcon />}
                          defaultParentIcon={<PublicOutlined />}
                          defaultExpandIcon={<ArrowRightIcon />}
                          defaultEndIcon={<div style={{ width: 50 }} />}
                          expanded={this.state.expanded}
                          onNodeToggle={(event, nodeIds) => {
                            event.persist();
                            // console.log(event.target.closest('div'));
                            // console.log(event.target.closest('div').matches('[class*="mui-jss-MuiTreeItem-iconContainer"]'));
                            let iconClicked = event.target.closest('div').matches('[class*="mui-jss-MuiTreeItem-iconContainer"]');
                            if (iconClicked) {
                              this.setState({ expanded: nodeIds });
                            }
                          }}
                          multiSelect={this.state.isMultiple}
                          onNodeSelect={(event, nodeIds) => {
                            event.persist();
                            let iconClicked = event.target.closest('div').matches('[class*="mui-jss-MuiTreeItem-iconContainer"]');
                            if (!iconClicked) {
                              this.setState({
                                onSelectIds: nodeIds,
                                firstSelectedId: false,
                              });
                              let idgroup = this.state.chartIdGroup.concat(
                                nodeIds
                              );
                              setChartIdGroup(idgroup);

                              if (idgroup.length > 1) {
                                setSelectedNodesInfo(
                                  idgroup.length + " entités sélectionnées"
                                );
                              } else if (idgroup.length == 1) {
                                setSelectedNodesInfo(groupInfoListById["" + idgroup[0]]);
                              }
                              // if (idgroup.length > 1) {
                              //   setSelectedNodesInfo(
                              //     idgroup.length + " entités sélectionnées"
                              //   );
                              // } else if (event.target.childNodes[0] && event.target.childNodes[0].nodeValue) {
                              //   setSelectedNodesInfo(
                              //     event.target.childNodes[0].nodeValue
                              //   );
                              // }
                              // else if (event.target.childNodes[0].childNodes[0] && event.target.childNodes[0].childNodes[0].nodeValue) {
                              //   setSelectedNodesInfo( 
                              //     event.target.childNodes[0].childNodes[0].nodeValue
                              //   );
                              // }
                              // else if (event.target.parentNode.childNodes[1] && event.target.parentNode.childNodes[1].nodeValue) {
                              //   setSelectedNodesInfo( 
                              //     event.target.parentNode.childNodes[1].nodeValue
                              //   );
                              // }
                              // else
                              // {
                              //   setSelectedNodesInfo('');
                              //   console.log('selected node info empty');
                              // }
                            }
                          }}
                          selected={this.state.onSelectIds}
                        >
                          {((this.state.isFiltered && this.state.newTree) || this.state.treeView) ?
                            <VirtualizedMenuEntites
                              ref={this.listRef}
                              size={size}
                              nodes={this.state.isFiltered === true ? this.state.newTree : this.state.treeView}
                              inactivehidden={this.state.inactivehidden}
                            /> : <></>
                          }

                        </TreeView>
                      )}
                    </AutoSizer>
                  );
                }}
              </AdvancedSearchContext.Consumer>
            </ThemeProvider>
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  render() {

    const { classes, bgColor } = this.props;

    const drawerPaper =
      classes.drawerPaperMenuEntites +
      " " +
      classes.drawerPaperRight +
      " " +
      cx({
        [classes.drawerPaperMiniFilters]:
          this.props.miniActive && this.state.miniActive,
      });

    const sidebarWrapper =
      classes.sidebarWrapperMenuEntites +
      " " +
      cx({
        [classes.drawerPaperMiniFilters]:
          this.props.miniActive && this.state.miniActive,
        [classes.sidebarWrapperWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1,
        [classes.hideWrapper]: this.props.miniActive && this.state.miniActive,
      });

    return (
      <div ref={this.mainPanel}>
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor="left"
            open={this.props.open}
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"],
            }}
            onClose={this.props.handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <Search />
            <SidebarWrapper className={sidebarWrapper} />
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            anchor="left"
            variant="permanent"
            open
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"],
            }}
          >
            <SidebarWrapper
              className={sidebarWrapper}
              tree={this.createTree()}
            />
          </Drawer>
        </Hidden>
      </div>
    );
  }


}

const VirtualizedMenuEntites = React.forwardRef((props, ref) => {
  const { size, nodes, inactivehidden } = props;
  const { width, height } = size;
  let nodesData = { ...nodes };
  let itemCount = nodes?.length ?? 1;
  return (
    <FixedSizeList
      width={width}
      height={height}
      itemCount={itemCount}
      itemSize={24}
      itemData={nodesData}
      className={"fixedelement"}
      ref={ref}
    >
      {({ index, data, style }) => VirtualizedTree({ index, data, style }, inactivehidden)}
    </FixedSizeList>
  );
});

// const VirtualizedMenuEntites = ({ ref, nodes, size }) => {
//   const { width, height } = size;
//   let nodesData = { ...nodes };
//   let itemCount = nodes?.length ?? 1;



//   return (
//     <FixedSizeList
//       width={width}
//       height={height}
//       itemCount={itemCount}
//       itemSize={24}
//       itemData={nodesData}
//       className={"fixedelement"}
//       ref={ref}
//     >
//       {VirtualizedTree}
//     </FixedSizeList>
//   );
// };

const VirtualizedTree = ({ index, data: node, style }, inactivehidden) => {
  const { nodeId, labelText, labelIcon, children, unselectedcolor, type, subtype } = node[index]?.props;

  return (
    <>
      <StyledTreeItem2
        key={nodeId}
        nodeId={nodeId}
        //labelText="Mes entités"
        labelIcon={labelIcon}
        labelInfo={labelText}
        unselectedcolor={unselectedcolor}
      // inactive={archiElement.r}
      >
        {Array.isArray(children)
          ? children.map((currentNode) => renderSubtree(currentNode.props, inactivehidden))
          : null}
      </StyledTreeItem2>
    </>
  );
};

const renderSubtree = ({ nodeId, labelIcon, labelText, children, unselectedcolor, hideinactive, inactive }, inactivehidden) => {
  if (hideinactive)
    return;
  return (
    <StyledTreeItem2
      key={nodeId}
      nodeId={nodeId}
      labelIcon={labelIcon}
      labelInfo={labelText}
      unselectedcolor={unselectedcolor}
      hideinactive={hideinactive}
      inactive={inactive}
    >
      {Array.isArray(children)
        ? children.map((node) => renderSubtree(node.props))
        : null}
    </StyledTreeItem2>
  );
};

const Scrollbar = ({
  scrollbarControlOuterRef,
  onScroll,
  children,
  style,
  forwardedRef,
}) => {
  const scrollbarRef = useRef(null);
  const scrollbarControlRef = useRef(null);

  useEffect(() => {
    scrollbarControlRef.current = new PerfectScrollbar(scrollbarRef.current, {
      minScrollbarLength: 17,
      wheelPropagation: false,
    });
  }, []);

  useEffect(() => {
    if (typeof forwardedRef === "function") forwardedRef(scrollbarRef.current);
  }, []);

  useEffect(() => {
    if (scrollbarControlOuterRef)
      scrollbarControlOuterRef.current = scrollbarControlRef.current;
  }, []);

  useEffect(() => {
    if (
      scrollbarControlOuterRef &&
      typeof (scrollbarControlOuterRef === "object")
    ) {
      scrollbarControlOuterRef.current = scrollbarControlRef.current;
    }
  }, []);

  return (
    <div
      onScroll={onScroll}
      className={"ps"}
      style={{ ...style, overflow: "hidden" }}
      ref={scrollbarRef}
    >
      {children}
    </div>
  );
};

MenuEntites.defaultProps = {
  bgColor: "blue",
  ids: [],
};

MenuEntites.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose",
  ]),
  logo: PropTypes.string,
  icon: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  miniActive: PropTypes.bool,
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  handleSelectDateChange: PropTypes.func,
  handleDpDateBeginChange: PropTypes.func,
  handleDpDateEndChange: PropTypes.func,
  handleCheckedAChange: PropTypes.func,
  handleGroupChange: PropTypes.func,
  //handleAdvancedSearch: PropTypes.func,
  ids: PropTypes.arrayOf(PropTypes.string),
  architecture: PropTypes.arrayOf(PropTypes.object),
};

SidebarWrapper.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  headerLinks: PropTypes.object,
  dates: PropTypes.object,
  tree: PropTypes.object,
};

export default withStyles(SidebarStyle)(MenuEntites);
